import React from 'react';
import { IoArrowBack } from 'react-icons/io5';
import { prefetchRoute } from '../../../../routes/routePrefetch';

export default function MobileMetroLevel3({
  level1Selection,
  level2Selection,
  getMainMenus,
  getSubSections,
  getMenuItems,
  isDemoProjectBootstrap,
  hasMenuAccess,
  online,
  hasUnreadOpsChat,
  setLevel,
  handleBack,
  handleMenuItemClick,
}) {
  if (!level1Selection || !level2Selection) return null;

  const menu = getMainMenus().find((m) => m.id === level1Selection);
  const section = getSubSections(level1Selection).find((s) => s.id === level2Selection);
  let items = getMenuItems(level1Selection, level2Selection);
  if (isDemoProjectBootstrap && level1Selection === 'settings' && level2Selection === 'master-data') {
    items = items.filter((item) => item.path === '/master-data/clients');
  }
  const isInventoryModule =
    level1Selection === 'inventory'
    || level1Selection === 'inventory-field-entry'
    || (level1Selection === 'administration' && level2Selection === 'inventory');
  if (isInventoryModule) {
    const invRouteByPath = {
      '/inventory': '/inventory/dashboard',
      '/inventory/new': '/inventory/new',
      '/inventory/mobile': '/inventory/mobile',
      '/inventory/mobile/new': '/inventory/new',
      '/inventory/kits': '/inventory/kits',
      '/inventory/parameters': '/inventory/parameters',
      '/inventory/vendors': '/inventory/vendors',
    };
    items = items.filter((item) => {
      const r = invRouteByPath[item.path];
      if (!r) return true;
      return hasMenuAccess(r) || hasMenuAccess('/inventory');
    });
  }

  return (
  <div className="mobile-metro-level mobile-metro-level-3">
    {/* Breadcrumbs */}
    <div className="mobile-metro-breadcrumbs">
      <div className="mobile-metro-breadcrumb" onClick={() => setLevel(1)}>
        <IoArrowBack className="breadcrumb-back-icon" />
        <menu.icon className="breadcrumb-icon" />
        <span className="breadcrumb-title">{menu.title}</span>
      </div>
      <div className="mobile-metro-breadcrumb" onClick={handleBack}>
        <span className="breadcrumb-title">{section.title}</span>
      </div>
    </div>

    {/* Menu items */}
    <div className="mobile-metro-items">
      {items.map((item, idx) => {
        const isChatOffline = item.path === '/operations/chat' && !online;
        const handlePrefetch = () => {
          if (!isChatOffline && item.path) prefetchRoute(item.path);
        };
        return (
        <div
          key={idx}
          className="mobile-metro-item"
          style={{
            animationDelay: `${idx * 30}ms`,
            ...(isChatOffline ? { opacity: 0.5, cursor: 'not-allowed', pointerEvents: 'none' } : {})
          }}
          onClick={() => handleMenuItemClick(item)}
          onTouchStart={handlePrefetch}
          onMouseEnter={handlePrefetch}
          onFocus={handlePrefetch}
        >
          {item.title}
          {item.path === '/operations/chat' && hasUnreadOpsChat && (
            <span className="ops-chat-unread-dot mobile-metro-list-dot" aria-label="Unread operations chat messages" />
          )}
        </div>
        );
      })}
    </div>
  </div>
  );
}
